import React from 'react'
import { VersionListCardContainer, VersionListCardNote } from './VersionList.styled'
import { Typography } from "@ann/web-components";

import dayjs from 'dayjs'

const VersionListCards = ({date, name}) => (

  <VersionListCardContainer>
	  <div>
		  <Typography  category="subtitle" weight="bold" size="small">
			  {dayjs(date).format('MMM D, YYYY')}
			</Typography>
		</div>
	  <VersionListCardNote>
		  <Typography  category="body" weight="regular" size="medium">
			  {dayjs(date).format('hh:mm A')} - {name}
			</Typography>
	  </VersionListCardNote>
	</VersionListCardContainer>
);

export default VersionListCards
